<style>
	.bgs12312312 {
		background-color: #f3f7f8;width:100%; 
	} 


.interact_menu{width: 20vw;float: left;background-color:#fafafa;margin-left: 7vw;margin-top: 6vw;
border: #e3e3e3 solid 1px;box-sizing: border-box;height: 45vw;}
.interact_menu input{width: 80%;margin: 0 auto;height: 3vw;border: #c9c9c9 solid 1px;display: block;margin: 0 auto;
margin-top: 1vw;outline: none;font-size: 1.3vw;text-align: center;}
.interact_menu button{display: block;width: 80%;height: 3vw;background-color: #3465ff;border: 0;outline: none;margin: 0 auto;
margin-top: 1vw;color: #fff;font-size: 1.2vw;font-weight: normal;color:#ddd;margin-bottom: 2vw;}



.interact_menu_div{width: 80%;margin: 0 auto;min-height: 4vw;cursor: pointer;}
.interact_menu_div_head{width: 100%;margin: 0 auto;height: 4vw;border-bottom: #e3e3e3 solid 1px;box-sizing: border-box;}
.interact_menu_div_head img.icon{width: 1.6vw;height: 1.6vw;display: block;float: left;margin-top: 1.2vw;}
.interact_menu_div_head span{display: block;float: left;line-height: 4vw;height: 4vw;width: 10vw;text-align: left;font-size: 1.3vw;
padding-left: 1vw;color: #000;}
.interact_menu_div_head img.jian{width: 1vw;height: 1vw;display: block;float: right;margin-top: 1.5vw;}
.interact_menu_div ul{margin: 0;padding: 0;overflow: hidden;height: 12vw;overflow-y: auto;}
.interact_menu_div ul li{margin: 0;padding: 0;width: 10vw;padding-left: 2.6vw;height: 3vw;font-size: 1.3vw;line-height: 3vw;}
.interact_menu_div ul li.on{color: #3465ff;}


 
</style>
<template>
	<div class="bgs12312312">
	   
		  
		  <div class="top_area">
		    <img @click="home()" src="../assets/images/home_icon.png">
			<div class="tabbar5">
			   <span class="pos">您的当前位置:</span>
			   <span class="floder">互动内容管理</span>
			   <span class="rights"></span>
			   <span class="floder">{{title}}</span>
			</div>
		 </div>
		 <div class="interact_menu">
		 	<input type="text" name="">
		 	<button>信息检索</button>
		 	<div class="interact_menu_div" v-for="item in interact_menu">
		 		<div class="interact_menu_div_head" @click="go_path(item.url,item.sub)">
			 		<img class="icon" :src="item.img">
			 		<span>{{item.name}}</span>
			 		<div v-if="item.sub">
			 		   <img class="jian"  @click="open_floder(item.id)"  v-if="item.floder" src="../assets/images/interact_up.png">
			 		   <img class="jian"  @click="close_floder(item.id)" v-else src="../assets/images/interact_down.png">
			 		</div>
		 	    </div>
		 	     
		 	    <ul v-if="item.sub && item.floder">
		 	    	<li v-for="items in item.sub_list" :class="items.on?'on':''" @click="go_sub_path(items.url)">{{items.name}}</li>
		 	    </ul>
		 	  
		 	</div>

		 </div>



	</div>
</template>
<script>
	export default {
	 
		data() {
			return {
		 			interact_menu:[{id:1,name:"内容管理",img:"../../../static/images/interact1.png",sub:true,floder:false,sub_list:[{id:1,name:"全部内容",on:true},{id:2,name:"校园风光"},{id:3,name:"视频剪辑"},{id:4,name:"名师风采"}]},
							   {id:2,name:"投票/调查",img:"../../../static/images/interact2.png",sub:false,sub_list:[],url:"/vote"},
							   {id:3,name:"Q&A管理",img:"../../../static/images/interact3.png",sub:false,sub_list:[],url:"/qa"},
							   {id:4,name:"留言管理",img:"../../../static/images/interact4.png",sub:false,sub_list:[],url:"/liu"},
							   {id:5,name:"数据分析",img:"../../../static/images/interact5.png",sub:true,floder:false,sub_list:[{id:1,name:"访问者数据",on:false,url:"/visit"},{id:2,name:"内容数据",on:false,url:"/data"}]}]
			}
		},props:["main","sub","title"],
		mounted() {
          var new_list=[];
          let self=this;                
					this.interact_menu.forEach(function(obj,index){
						new_list[index]=obj;
						if(obj.id==self.main){
	              new_list[index].floder=true;
	              var new_list2=[];
	              obj.sub_list.forEach(function(objs,indexs){
										new_list2[indexs]=objs;
										if(objs.id==self.sub){
					              new_list2[indexs].on=true;
										} 
								});
								 new_list[index].sub_list=new_list2; 
						} 
					});
          this.interact_menu=new_list; 
		}, 
		methods: {
			 go_path(path,sub){
			 	      if(sub==false){
                this.$router.push(path);  
			 	      }
			 },
			 go_sub_path(path){
                this.$router.push(path);  
			 },
		   open_floder(id){
                var new_list=[];                   
								this.interact_menu.forEach(function(obj,index){
									new_list[index]=obj;
									if(obj.id==id){
				                        new_list[index].floder=false;
									} 
								});
			          this.interact_menu=new_list; 
			 },
			 close_floder(id){
                var new_list=[];    
								this.interact_menu.forEach(function(obj,index){
									new_list[index]=obj;
									if(obj.id==id){
				                        new_list[index].floder=true;
									} 
								});
			         this.interact_menu=new_list; 
			 },
		},watch:{
			 
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/interact.vue